// Client-side streak math. Inputs are arrays of { date: 'YYYY-MM-DD', ... }
// pulled from daily_briefing / daily_checkout. We DON'T store streaks — they're
// derived from the records that already exist.

import { lastNDates } from './dates.js';

// Count consecutive days back from today where `pred(row)` is true.
// `rows` is an array; we look it up by date.
function streakFrom(rows, pred) {
  const byDate = new Map();
  for (const r of rows) byDate.set(r.date, r);
  let streak = 0;
  for (const date of lastNDates(365)) {
    const row = byDate.get(date);
    if (row && pred(row)) streak += 1;
    else break;
  }
  return streak;
}

export function morningBriefingStreak(briefings) {
  return streakFrom(briefings, (r) => !!r.completed_at);
}

export function checkoutStreak(checkouts) {
  return streakFrom(checkouts, (r) => !!r.completed_at);
}

export function devotionalStreak(briefings) {
  return streakFrom(briefings, (r) => r.devotional === true);
}

export function workoutStreak(briefings) {
  return streakFrom(briefings, (r) => r.workout === true);
}

// 30-day mini-heatmap: array of { date, hit } newest → oldest.
export function heatmap(rows, pred, days = 30) {
  const byDate = new Map();
  for (const r of rows) byDate.set(r.date, r);
  return lastNDates(days).map((date) => ({
    date,
    hit: !!(byDate.get(date) && pred(byDate.get(date))),
  }));
}
